import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import styles from "./index.module.css";

import useDims from "../atoms/useDims";
import { checkIsPC } from "../atoms";
import {
  activeSectionWidthRatios as rWidth,
  activeSectionHeightRatios as rHeight,
  TRANSITON_SPEED
} from "../../constants";

const Divider = ({ activeSection, showingModal, width, height }) => {
  const [init, setInit] = useState(true);
  const transition = init ? TRANSITON_SPEED.initial : TRANSITON_SPEED.default;
  const initVariants = {
    pc: {
      bottom: 0,
      top: "initial"
    },
    mobile: {
      left: 0
    }
  };
  const variants = {
    // when work is active
    work: {
      // work divider is 66%
      work: {
        pc: {
          left: width * rWidth.work.work,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: height - 67 * 2, left: 0 }
      },
      // team divier is 83%
      team: {
        pc: {
          left: width * rWidth.work.team,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: height - 66, left: 0 }
      }
    },
    team: {
      work: {
        pc: {
          left: width * rWidth.team.work,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: 132, left: 0 }
      },
      team: {
        pc: {
          left: width * rWidth.team.team,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: height - 68, left: 0 }
      }
    },
    about: {
      work: {
        pc: {
          left: width * rWidth.about.work,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: 132, left: 0 }
      },
      team: {
        pc: {
          left: width * rWidth.about.team,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: 195, left: 0 }
      }
    },
    default: {
      work: {
        pc: {
          left: width * rWidth.default.work,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: height * rHeight.default.work + 48, left: 0 }
      },
      team: {
        pc: {
          left: width * rWidth.default.team,
          bottom: 0,
          top: "initial",
          transition: transition
        },
        mobile: { top: height * rHeight.default.team + 26, left: 0 }
      }
    }
  };

  const isPC = checkIsPC(width);
  if (!variants[activeSection]) {
    activeSection = "default";
  }

  // needs animation hooks to move around
  return (
    <motion.div
      className={styles.container}
      animate={{ opacity: showingModal && !isPC ? 0 : 1 }}
    >
      <motion.div
        className={styles.divider}
        initial={isPC ? initVariants.pc : initVariants.mobile}
        animate={
          variants[activeSection] && isPC
            ? variants[activeSection].work.pc
            : variants[activeSection].work.mobile
        }
        onAnimationComplete={() =>
          setTimeout(() => {
            setInit(false);
          }, 300)
        }
      />
      <motion.div
        className={styles.divider}
        initial={isPC ? initVariants.pc : initVariants.mobile}
        animate={
          variants[activeSection] && isPC
            ? variants[activeSection].team.pc
            : variants[activeSection].team.mobile
        }
      />
    </motion.div>
  );
};

const getSection = current => {
  switch (current) {
    case "/":
      return "default";
    case "/works":
      return "work";
    case "/about":
      return "about";
    case "/teams":
      return "team";
    default:
      return "default";
  }
};

// literally a border overlay
const AnimatedSection = ({ current, showingModal, children }) => {
  const { height, width } = useDims({ height: 0, width: 0 });

  const [section, setSection] = useState(getSection(current) || "default");
  useEffect(() => {
    if (section !== getSection(current)) {
      setSection(getSection(current));
    }
  }, [current, section]);

  return (
    <div className={styles.screenContainer}>
      <Divider
        activeSection={section}
        width={width}
        height={height}
        showingModal={showingModal}
      />
    </div>
  );
};

export default AnimatedSection;
